import { MD5 } from '@/utils/md5.js';
const md5 = new MD5();
export const encrypt = function(text) {
  if (typeof text === 'undefined' || text === null || text === '') return '';
  return md5.b64_md5('P%y2K&ja' + text);
};
